import { render, staticRenderFns } from "./jmjsh.vue?vue&type=template&id=0820ae40&scoped=true&"
import script from "./jmjsh.vue?vue&type=script&lang=js&"
export * from "./jmjsh.vue?vue&type=script&lang=js&"
import style0 from "./jmjsh.vue?vue&type=style&index=0&id=0820ae40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820ae40",
  null
  
)

export default component.exports